import axios from 'axios';
import { toast } from 'react-toastify';
// const baseURL = 'http://3.134.233.50:8080/api'; //dev url
const baseURL = 'http://3.136.175.105:8080/api';
const admin_token = localStorage.getItem('admin_token');

export const fetchData = async (url, method, data = {}) => {

  const config = {
    url,
    method,
    baseURL,
    data,
    headers: {
      'Authorization': `Bearer ${admin_token}`
    },
  }

  try {
    const response = await axios.request(config)
    return response.data;
  } catch(err) {
    switch(err.response.status){
      case 400: return toast.error('Bad Request')
      case 403: return toast.error('Forbidden')
      case 500: return toast.error('Internal Server Error')
      case 501: return toast.error('Not Implemented')
      case 502: return toast.error('Bad Gateway')
      case 503: return toast.error('Service Unavailable')
      case 504: return toast.error('Gateway Timeout')
      default: break;
    }
    return { err: err.response };
  }
   
}
